import { getLovLabel } from '@zoryn/hooks'
import { formatDateDisplayText, isDateColumnType } from '../utils/date-cell'
import { resolveFileCellDisplayName } from '../utils/file-cell'
import { resolveLovDisplayField } from '../utils/input-table-picker'
import { formatSwitchDisplayText } from '../utils/switch-cell'
import type { GridColumnInfo } from '../types'

/** 与 grid-cell displayText 只读展示逻辑保持一致，供列宽估算使用 */
export function resolveCellDisplayText(
  row: Record<string, unknown>,
  column: GridColumnInfo
): string {
  if (!column.field) {
    return ''
  }

  const val = row[column.field]

  if (column.formatter) {
    return column.formatter({ row, column, cellValue: val })
  }

  if (column.type === 'table') {
    const displayField = resolveLovDisplayField(column)
    if (displayField && row[displayField] != null && row[displayField] !== '') {
      return String(row[displayField])
    }
  }

  if (column.type === 'lov' && column.lovType) {
    const displayField = resolveLovDisplayField(column)
    if (displayField && row[displayField] != null && row[displayField] !== '') {
      return String(row[displayField])
    }
    return getLovLabel(column.lovType, val) || (val == null ? '' : String(val))
  }

  if (column.type === 'switch') {
    return formatSwitchDisplayText(val)
  }

  if (column.type === 'file' || column.type === 'files') {
    const meta = row[`${column.field}Meta`]
    return resolveFileCellDisplayName(
      val,
      meta as Parameters<typeof resolveFileCellDisplayName>[1]
    )
  }

  if (isDateColumnType(column.type)) {
    return formatDateDisplayText(val, column.type)
  }

  if (val == null) {
    return ''
  }

  return String(val)
}
